import React from "react";

import _ from "lodash";

import InputTextField from "./InputTextField";

import "./InvoiceEmailRecipients.scss";

class InvoiceEmailRecipients extends React.Component {
  state = {
    initializationComplete: false,
  };

  fieldConfiguration = null;

  constructor(props) {
    super(props);

    if (props.fieldConfiguration) {
      this.fieldConfiguration = props.fieldConfiguration;
    }
  }

  componentDidMount() {
    this.setState({
      emails: this.props.payor.fields.billing_emails.value || [],
    });
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.payor.fields, prevProps.payor.fields)) {
      this.setState({
        emails: this.props.payor.fields.billing_emails.value || [],
      });
    }
  }

  _onLineItemEntryChange(ident) {
    return (value) => {
      this.props.onLineItemEntryChange(ident, value);
    };
  }

  addBlankEntryToTable() {
    const emails = this.state.emails;
    const entry = {
      email: "",
      email_id: Math.random().toString(36).substr(2, 9),
    };
    emails.push(entry);
    this._onLineItemEntryChange(null)(emails);
  }

  handleAddEntryClick = () => {
    this.addBlankEntryToTable();
  };

  handleChange = (id, value, email_id) => {
    const emails = this.state.emails;
    const filteredEmail = emails.map((email) =>
      id
        ? email.id === id
          ? { ...email, email: value }
          : email
        : email.email_id === email_id
        ? { ...email, email: value }
        : email
    );
    this._onLineItemEntryChange(null)(filteredEmail);
  };

  handleDeleteClick = (id, email_id) => {
    let emails = this.state.emails.map((email) =>
      id
        ? id === email.id
          ? { id: email.id, action: "DELETE" }
          : email
        : email
    );
    emails = !id
      ? emails.filter((email) => email.email_id !== email_id)
      : emails;

    this._onLineItemEntryChange(null)(emails);
  };

  validateEmail = (email) => {
    // Validates email
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  render() {
    const { payor, editMode } = this.props;

    const billing_emails = payor.fields.billing_emails.value || [];
    const totalEmails = billing_emails.filter((i) => !i.action);
    return (
      <div className="invoice-email-recipient-table">
        <div className="invoice-email-recipient-table--help-text">
          <span>
            Select Edit button to add up to 5 Invoice email recipients (this
            includes all monthly Invoice emails)
          </span>
        </div>
        <React.Fragment>
          <header className="invoice-email-recipient-table--header">
            <div className="invoice-email-recipient-table--row">
              <div className="invoice-email-recipient-table--type-column invoice-email-recipient-table--cell">
                <span className="invoice-email-recipient-table--column-heading">
                  Recipients
                </span>
              </div>
            </div>
          </header>
          <div className="invoice-email-recipient-table--body">
            {billing_emails?.map(
              (i, index) =>
                !i.action && (
                  <div
                    className="invoice-email-recipient-table--row"
                    key={i.id}
                  >
                    <div className="invoice-email-recipient-table-row">
                      <div className="invoice-email-recipient-table--input-column invoice-email-recipient-table--cell">
                        <div className="invoice-email-recipient-table-input">
                          <InputTextField
                            value={i.email}
                            editMode={editMode}
                            onChange={(value) =>
                              this.handleChange(i.id, value, i.email_id)
                            }
                          />
                          {editMode && (
                            <button
                              type="button"
                              className="parkchirp--button-as-link"
                              onClick={() =>
                                this.handleDeleteClick(i.id, i.email_id)
                              }
                            >
                              Delete
                            </button>
                          )}
                        </div>
                        {i.email && !this.validateEmail(i.email) && (
                          <span className="error-msg">
                            Please enter valid email
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                )
            )}
            {editMode && totalEmails?.length < 5 && (
              <div className="invoice-email-recipient-table--row">
                <div className="invoice-email-recipient-table--add-entry-column invoice-email-recipient-table--add-entry-row invoice-email-recipient-table--cell">
                  <button
                    type="button"
                    className="parkchirp--button-as-link"
                    onClick={this.handleAddEntryClick}
                  >
                    Add Recipient
                  </button>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      </div>
    );
  }
}

export default InvoiceEmailRecipients;
